import { DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCashReceiptJournalReport extends Layout {
    excludabletextboxCust: ExcludableTextbox;
    excludabletextboxGL: ExcludableTextbox;
    sourceCashReceiptJournal: DataSource;
    switchSortBy: Switch;
    textboxDateRange: Textbox;
    textboxReportType: Textbox;
}
